module.exports = __webpack_public_path__ + "static/media/main9.bc9ed8f3.png";